'use client'
import { useState, useEffect, useRef } from 'react'
import { PrismicRichText, PrismicText } from '@prismicio/react'
import { PrismicNextImage } from'@prismicio/next'
import * as prismic from "@prismicio/client"
import { createClient } from '@/prismicio'
import CloseButton  from '@/assets/images/icons/close-button.svg'

interface SearchProps {
  core?: any | null;
  setSearchState?: any | null;
}

const Search:React.FC<SearchProps>  =({ core, setSearchState })=> {

  const [searchResults, setSearchResults] = useState([""]);
  const [searchTerm, setSearchTerm] = useState(null) as any
  const searchRef = useRef(null) as any

  const searchText = async (e: any, search_term: string)=>{
    setSearchTerm(search_term)
    if(search_term) {
      if(e || e.key ==='Enter') {
        const client = createClient()
          const response = await client.get({
            filters: [
              prismic.filter.any('document.type', ['section','home_page','article','faq']),
              prismic.filter.fulltext('document', search_term),
              prismic.filter.not('document.tags', ['Informer Library']),
            ],
          }) as any
      if (response) {
        return setSearchResults(response.results);
      }
      }
    }
  }
  let searchAssets =[] as any
  core.data.slices.map((slice: any) => {
      if(slice.slice_type==="search") {
          searchAssets = slice;
      }
      return null;
  })

  // console.log(props)

  useEffect(()=>{
    const paramsString = new URL(window.location.href);
    const searchParams = new URLSearchParams(paramsString.search)
    const search = searchParams.get('s') as any
    searchRef.current.value = search
    searchText("Enter", search)

  }, [])

  return (
    <div className="w-full bg-jade fixed top-0 h-screen left-0 z-[100] font-fellix">
      <div className="max-w-[1180px] mx-auto relative py-12 h-screen px-4">
          <div className="absolute top-12 right-4"  onClick={()=>{setSearchState(false); document.body.style.overflow="visible"}}><CloseButton/></div>
          <div className="grid grid-cols-12 gap-0 mt-24">
            <div className="col-span-10 md:col-span-11">
              <input className="bg-transparent outline-none appearance-none font-semibold text-5xl leading-[60px] text-[#f2f2f2]" type="text" onKeyUp={(e: any)=>searchText(e, e.target.value) } placeholder={searchAssets.primary.placeholder_text} ref={searchRef}/>
            </div>
            <div className="col-span-2 md:col-span-1 flex justify-end">
              <PrismicNextImage field={searchAssets.primary.icon} fallbackAlt="" className="w-[30px] relative" onClick={(e)=>searchText(e, searchTerm)}/>
            </div>
          </div>
          <PrismicNextImage field={searchAssets.primary.search_line} fallbackAlt="" className="object-cover h-[9px] mt-2"/>
          <div className="text-white mt-12 overflow-y-scroll h-[60dvh] pb-24 pr-4">
            {searchResults && searchResults.length >0 ? 
                <ul>
                {searchResults.map((item: any, index: number)=>{

                  let pageType="" as string
                  let pageData="" as any
                  let pageLink="" as any
                  let pageDescription ="" as any

                  if(item.type === 'section' || item.type === 'home_page' || item.type === 'article' || item.type === 'faq') {
                    switch(item.type) {
                      case "article":
                        pageType="articles/"
                        pageData= item.data.article_title
                        pageLink = item.uid+"?s="+searchTerm
                        pageDescription = item.data.seo_description
                      break
                      case "faq":
                        pageType=""
                        pageData= item.data.question
                        pageLink = "faqs?f="+item.id+"&s="+searchTerm
                        pageDescription = item.data.answer
                      break
                      default: 
                      pageType="";
                      pageData= item.data.page_title
                      pageLink = item.uid+"?s="+searchTerm
                      pageDescription = item.data.meta_description
                    }
                    return (
                        <li key={index} className="my-4">
                          <a href={"/"+pageType+pageLink}>
                            {item.type === "faq" ?
                            <>
                              <h3 >{pageData}</h3>
                              <p>View in the Frequently Asked section</p>
                            </> :
                            <>
                              <article className="font-semibold"><PrismicRichText field={pageData}/></article>
                              <p className="text-[12px]">{pageDescription}</p>
                            </>
                            }
                          </a>
                        </li>
                    )
                  } else 
                  { return null }
                })}
                </ul>
            : <article className="text-[28px]"><PrismicText field={searchAssets.primary.no_results}/> <strong>{searchTerm}</strong></article>}
          </div>
      </div>
    </div>
  )
}
export default Search;
